(function () {
  angular.module('7Terminal.Common')
    .filter('dateToISO', function dateToISO() {
      return function (input) {
        if (!input) return '';
        return new Date(input).toISOString();
      };
    });
})();
